import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";

import styles from "./CoachingPerformanceViewResults.module.css";
import { connect } from "react-redux";
import { AiFillPrinter } from "react-icons/ai";
import { deleteGrade, getGradeList } from "../../actions/Grade.action";
import { years } from "../../constants/MonthsAndYears";
import { getGrade } from "../../utils/getGrade";
import {
  getTermOptions,
  getTermLabel,
  getTermCountOptions,
} from "../../utils/coachingPerformance";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import SectionHeading from "../SectionHeading/SectionHeading";
import { getAllCoachingPerformance } from "../../actions/CoachingPerformance.action";

const CoachingPerformanceViewResults = ({
  list,
  getGradeList,
  extra,
  grades,
  getAllCoachingPerformance,
}) => {
  const [rawList, setRawList] = useState(list === null ? [] : list);
  const [grade, setGrade] = useState("");
  const [batch, setBatch] = useState("");
  const [shift, setShift] = useState("");
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [termCount, setTermCount] = useState("");
  const [term, setTerm] = useState("");

  const ref = useRef(null);

  const gradeCalculate = (status) => {
    if (rawList) {
      let count = 0;
      rawList.map((item) => {
        if (
          item?.coachingPerformances.length > 0 &&
          getGrade(item?.coachingPerformances[0]?.percent.toFixed(0)) === status
        ) {
          count++;
        }
      });
      return count;
    }
    return 0;
  };

  useEffect(() => {
    if (grades === null) {
      getGradeList();
    }
    if (list !== null) {
      setRawList(list);
    }
  }, [list]);

  const selectHandeler = async () => {
    if (!term) {
      return;
    }
    await getAllCoachingPerformance(batch, year, term, grade, shift);
  };

  // Get term options based on selected term count
  const termOptions = termCount ? getTermOptions(parseInt(termCount)) : [];

  return (
    <Container className="pb-4">
      <Card bg="white" text="dark" className={`crd shadow`}>
        <Card.Body>
          <Row>
            <Col md={3} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="grade" className="d-block">
                  Class
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setBatch("");
                  setShift("");
                  setGrade(e.target.value);
                }}
              >
                <option value={""}>Select Class</option>
                {grades &&
                  grades.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </Form.Select>
            </Col>
            {grades && grade !== "" ? (
              <Col md={3} className="py-3">
                <div className="d-flex justify-content-between align-items-center pb-2">
                  <label htmlFor="shift" className="d-block">
                    Shift
                  </label>
                </div>
                <Form.Select
                  onChange={(e) => {
                    setBatch("");
                    setShift(e.target.value);
                  }}
                >
                  <option value={""}>Select Shift</option>
                  {grades
                    .filter((grd) => grd.id === parseInt(grade))[0]
                    .shifts.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            ) : (
              <></>
            )}
            {grade !== "" && shift !== "" ? (
              <Col md={3} className="py-3">
                <div className="d-flex justify-content-between align-items-center pb-2">
                  <label htmlFor="batch" className="d-block">
                    Batch
                  </label>
                </div>
                <Form.Select onChange={(e) => setBatch(e.target.value)}>
                  <option value={""}>Select Batch</option>
                  {grades
                    .filter((grd) => grd.id === parseInt(grade))[0]
                    .batches.filter((bt) => bt.shiftId === parseInt(shift))
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            ) : (
              <></>
            )}
            {grade !== "" ? (
              <Col
                md={3}
                className="d-md-flex d-none jsutify-content-end align-items-end py-3"
              >
                <Button
                  onClick={selectHandeler}
                  variant="primary"
                  type="submit"
                  className="btn_primary"
                >
                  Select
                </Button>
              </Col>
            ) : (
              <></>
            )}
          </Row>
          <Row>
            <Col md={4} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="termCount" className="d-block">
                  Term Count (Optional)
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setTermCount(e.target.value);
                  if (term && e.target.value && parseInt(term) > parseInt(e.target.value)) {
                    setTerm("");
                  }
                }}
                id="termCount"
                name="termCount"
                value={termCount}
              >
                <option value={""}>All</option>
                {getTermCountOptions().map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={4} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="term" className="d-block">
                  Term Type
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setTerm(e.target.value);
                }}
                id="term"
                name="term"
                value={term}
              >
                <option value={""}>Select Term Type</option>
                {termCount
                  ? termOptions.map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    ))
                  : getTermOptions(2)
                      .concat(getTermOptions(3))
                      .filter((v, i, a) => a.findIndex((t) => t.value === v.value) === i)
                      .map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.label}
                        </option>
                      ))}
              </Form.Select>
            </Col>
            <Col md={4} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="year" className="d-block">
                  Year
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setYear(e.target.value);
                }}
                id="year"
                name="year"
                value={year}
              >
                {years.map((item, i) => (
                  <option key={i} value={`${item}`}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col
              md={4}
              className="d-flex d-md-none jsutify-content-end align-items-end py-3"
            >
              <Button
                onClick={selectHandeler}
                variant="primary"
                type="submit"
                className="btn_primary"
              >
                Select
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      {rawList !== null ? (
        <Card className="crd p-md-2 pb-md-0 p-2 mt-4">
          <Card.Body>
            {rawList === null ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: 600 }}
              >
                <Spinner variant="dark" animation="grow" />
              </div>
            ) : rawList.length === 0 ? (
              <span className="text-center fs-4 d-block pb-3">
                No Coaching Performance Found
              </span>
            ) : (
              <>
                <div className="d-flex justify-content-end ">
                  <div className="">
                    <ReactToPrint
                      documentTitle={`Coaching Performance Marksheet - ${rawList[0].batch.name} `}
                      content={() => ref.current}
                    >
                      <PrintContextConsumer>
                        {({ handlePrint }) => (
                          <span
                            className={styles.chart_icon}
                            onClick={handlePrint}
                          >
                            <AiFillPrinter />
                          </span>
                        )}
                      </PrintContextConsumer>
                    </ReactToPrint>
                  </div>
                </div>
                <div className="p-3" ref={ref}>
                  {extra ? (
                    <SectionHeading
                      title={`${getTermLabel(extra.termCount || termCount || 2, extra.term)} ${extra.year} Coaching Performance Report`}
                      batch={extra.batchId}
                      shift={extra.shiftId}
                      grade={extra.gradeId}
                      year={extra.year}
                    />
                  ) : (
                    <></>
                  )}

                  <div className="d-flex align-items center justify-content-center pb-5">
                    <div className="d-flex justify-content-center pt-4">
                      <span className="d-block pe-3">
                        <span className="fw-bold">A++</span> = (91-100)
                      </span>
                      <span className="d-block pe-3">
                        <span className="fw-bold">A+</span> = (81-90)
                      </span>
                      <span className="d-block pe-3">
                        <span className="fw-bold">A</span> = (71-80)
                      </span>
                      <span className="d-block pe-3">
                        <span className="fw-bold">A-</span> = (61-70)
                      </span>
                      <span className="d-block pe-3">
                        <span className="fw-bold">B</span> = (51-60)
                      </span>
                      <span className="d-block pe-3">
                        <span className="fw-bold">C</span> = {"(<51)"}{" "}
                      </span>
                    </div>
                  </div>
                  <Table striped bordered hover className="mb-5">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Roll</th>
                        {!extra || extra.shiftId === "" ? (
                          <th>Shift</th>
                        ) : (
                          <></>
                        )}
                        {!extra || extra.batchId === "" ? (
                          <th>Batch</th>
                        ) : (
                          <></>
                        )}

                        <th>Percent</th>
                        <th>Grade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rawList !== null &&
                        rawList
                          .sort(function (a, b) {
                            if (parseInt(a.uid) < parseInt(b.uid)) return -1;
                            if (parseInt(a.uid) > parseInt(b.uid)) return 1;
                            return 0;
                          })
                          .map((markItem, i) => (
                            <tr key={markItem.id}>
                              <td>{markItem.name}</td>
                              <td>{markItem.uid}</td>
                              {!extra || extra.shiftId === "" ? (
                                <td>{markItem.shift.name}</td>
                              ) : (
                                <></>
                              )}
                              {!extra || extra.batchId === "" ? (
                                <td>{markItem.batch.name}</td>
                              ) : (
                                <></>
                              )}

                              <td>
                                {markItem.coachingPerformances.length > 0
                                  ? markItem.coachingPerformances[0].percent.toFixed(0) + "%"
                                  : "N/A"}
                              </td>
                              <td>
                                {markItem.coachingPerformances.length > 0
                                  ? getGrade(
                                      markItem.coachingPerformances[0].percent.toFixed(0)
                                    )
                                  : "Absent"}
                              </td>
                            </tr>
                          ))}
                    </tbody>
                  </Table>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="d-flex">
                      <span className="d-block pe-3">
                        <span className="fw-bold">A++</span> ={" "}
                        {gradeCalculate("A++")}
                      </span>
                      <span className="d-block pe-3">
                        <span className="fw-bold">A+</span> ={" "}
                        {gradeCalculate("A+")}
                      </span>
                      <span className="d-block pe-3">
                        <span className="fw-bold">A</span> ={" "}
                        {gradeCalculate("A")}
                      </span>
                      <span className="d-block pe-3">
                        <span className="fw-bold">A-</span> ={" "}
                        {gradeCalculate("A-")}
                      </span>
                      <span className="d-block pe-3">
                        <span className="fw-bold">B</span> ={" "}
                        {gradeCalculate("B")}
                      </span>
                      <span className="d-block pe-3">
                        <span className="fw-bold">C</span> ={" "}
                        {gradeCalculate("C")}
                      </span>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      ) : (
        <></>
      )}
    </Container>
  );
};

const mapStateToProps = (state) => ({
  list: state.coachingPerformance.all,
  extra: state.coachingPerformance.extra,
  grades: state.grade.grade,
});

export default connect(mapStateToProps, {
  getGradeList,
  deleteGrade,
  getAllCoachingPerformance,
})(CoachingPerformanceViewResults);
